export default class Alert {
  constructor(el) {
    this.el = el;
    const fixedClass = 's-header-fixed';
    const header = document.querySelector('.g-header');
    const main = document.querySelector('main');

    const home = document.querySelectorAll('.home.page');

    if (home && home.length) {
      setTimeout(function () {
        document.body.classList.add('s-alert-visible');
        main.classList.remove('pt-20', 'lg:pt-36');
        header.style.marginTop = `${el.offsetHeight}px`;
      }, 1000);

      window.addEventListener('resize', function () {
        document.body.classList.add('s-alert-visible');
        header.style.marginTop = `${el.offsetHeight}px`;
      });

      window.addEventListener('scroll', function () {
        el.style.transform = `translateY(-${window.scrollY}px)`;
        if (window.scrollY >= el.offsetHeight) {
          document.body.classList.add(fixedClass);
          document.body.style.paddingTop = `${el.offsetHeight}px`;
        } else {
          document.body.classList.remove(fixedClass);
          document.body.style.paddingTop = '';
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/Alert.js